import { useState, useEffect } from "react";
import { batchesAPI } from "../services/api";
import { log } from "three/src/nodes/TSL.js";

// Custom hook for fetching batch statistics
export const useBatchStats = () => {
  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchBatchStats = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await batchesAPI.getBatchStats();
      setBatches(response.stats || []);
    } catch (err) {
      setError(err.message);
      console.error("Error fetching batch stats:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBatchStats();
  }, []);

  return {
    batches,
    loading,
    error,
    refetch: fetchBatchStats,
  };
};

// Custom hook for batch CRUD operations
export const useBatchOperations = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateBatch = async (batchId, batchData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await batchesAPI.updateBatch(batchId, batchData);
      return response;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const deleteBatch = async (batchId) => {
    setLoading(true);
    setError(null);
    try {
      const response = await batchesAPI.deleteBatch(batchId);
      return response;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const addBatch = async (batchName, jsonFile) => {
    setLoading(true);
    setError(null);
    try {
      const response = await batchesAPI.addBatch(batchName, jsonFile);
      return response;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    updateBatch,
    deleteBatch,
    addBatch,
    loading,
    error,
  };
};
